var map = {
	"./br/PT/S1/bg_p118.jpg": 66555,
	"./br/PT/bg_p118.jpg": 90902,
	"./in/EN/S1/bg_p118.jpg": 17695,
	"./ph/EN/S1/bg_p118.jpg": 40413,
	"./ph/EN/bg_p118.jpg": 28911,
	"./vn/VI/S1/bg_p118.jpg": 61678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17522;